<template>
  <b-container fluid="sm">
    <b-row v-if="creationStep < 5">
      <b-col lg="10" offset-lg="1">
        <b-progress class="creation-progress" :max="totalSteps">
          <b-progress-bar class="creation-progress-bar" :value="creationStep"></b-progress-bar>
        </b-progress>

        <div class="d-flex justify-content-around my-4">
          <div class="step-marker" :class="creationStep >= step ? 'visited-step' : ''" v-for="step in steps"
               :key="step">
            <span>{{ step }}</span>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div class="inputContainer">
          <step-one v-if="creationStep === 1"/>
          <step-two v-if="creationStep === 2"/>
          <step-three v-if="creationStep === 3"/>
          <step-four v-if="creationStep === 4"/>
          <final-step v-if="creationStep === 5"/>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import {mapGetters} from 'vuex'

import './style.scss'
import FinalStep from "./steps/finalStep";
import StepOne from './steps/stepOne'
import StepTwo from "./steps/stepTwo";
import StepThree from './steps/stepThree'
import StepFour from './steps/stepFour'

export default {
  name: 'formInput',

  components: {
    FinalStep, StepOne, StepTwo, StepThree, StepFour,
  },

  data() {
    return {
      totalSteps: 4
    }
  },

  computed: {
    ...mapGetters(['creationStep']),

    steps() {
      return Array.from({length: this.totalSteps}, (_, i) => i + 1)
    }
  },
}
</script>
